import { AppThunkAction } from "..";
import { KnownAction, GET_BANNER_ALERT_MESSAGE, AlertMessageBanner, LOADER_FOR_BANNER_ALERT_MESSAGE, RESET_FOR_BANNER_ALERT_MESSAGE } from "./types";
import * as httpClient from "../../util/httpClient";

export const actionCreators = {
    getBannerAlertMessage:
        (needToRefresh?: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            const state = getState();
            if (
                state.alertMessageBannerState &&
                state.alertMessageBannerState.isLoadingBannerMessage === false &&
                state.alertMessageBannerState.alertMessageBanner &&
                (needToRefresh || !state.alertMessageBannerState.alertMessageBanner.length)
            ) {
                dispatch({ type: LOADER_FOR_BANNER_ALERT_MESSAGE, isLoadingBannerMessage: true });
                httpClient
                    .sendRequest("POST", "api/messageBanner/getAlertMessageBanner")
                    .then((data) => {
                        const alerts = data["messageBanner"]["alertMessageBanners"];

                        if (alerts) {
                            alerts.sort(function (a: AlertMessageBanner, b: AlertMessageBanner) {
                                if (a.messageLevel && b.messageLevel) {
                                    if (a.messageLevel < b.messageLevel) {
                                        return -1;
                                    }
                                    if (a.messageLevel > b.messageLevel) {
                                        return 1;
                                    }
                                }
                                return 0;
                            });
                            dispatch({ type: GET_BANNER_ALERT_MESSAGE, alertMessageBanner: alerts });
                        }
                        dispatch({ type: LOADER_FOR_BANNER_ALERT_MESSAGE, isLoadingBannerMessage: false });
                    })
                    .catch(function (error) {
                        dispatch({ type: LOADER_FOR_BANNER_ALERT_MESSAGE, isLoadingBannerMessage: false });
                    });
            }
        },
    resetBannerAlertMessage: (): AppThunkAction<KnownAction> => (dispatch) => {
        dispatch({ type: RESET_FOR_BANNER_ALERT_MESSAGE });
    },
};
